import { HasDefaultReturnWindowProvider } from "@faire/retailer-visitor-shared/components/ExtendReturnsModal/useHasDefaultReturnWindow";
import { RetailerFlashSaleProvider } from "@faire/retailer-visitor-shared/hooks/retailer/useFlashSale";
import { RetailerMultipleStoresProvider } from "@faire/retailer-visitor-shared/hooks/retailer/useHasEverHadMultipleStores";
import { RetailerInsiderProvider } from "@faire/retailer-visitor-shared/hooks/retailer/useInsider";
import { RetailerNationalityProvider } from "@faire/retailer-visitor-shared/hooks/retailer/useNationality";
import { RetailerPaymentTermProvider } from "@faire/retailer-visitor-shared/hooks/retailer/usePaymentTerm";
import { RetailerFinancialProvider } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailerFinancial";
import { RetailerStatusProvider } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailerStatus";
import { RetailerTypeProvider } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailerType";
import { RetailerHighReturnerProvider } from "@faire/retailer-visitor-shared/hooks/retailer/useShouldShowHighReturnerOrderNudges";
import { RetailerSubUserProvider } from "@faire/retailer-visitor-shared/hooks/retailer/useSubUser";
import { IsRetailerCreatedWithinLast30DaysProvider } from "@faire/retailer-visitor-shared/stores/ui/useIsRetailerCreatedWithinLast30Days";
import { ExpandingOfferProvider } from "@faire/retailer-visitor-shared/views/expanding-retailers/useExpandingOffer";
import { RetailerBusinessCategoryProvider } from "@faire/retailer-visitor-shared/views/underwriting-request/useRetailerBusinessCategory";

export const RetailerProviders: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <RetailerFinancialProvider>
      <RetailerTypeProvider>
        <RetailerStatusProvider>
          <RetailerHighReturnerProvider>
            <RetailerSubUserProvider>
              <RetailerPaymentTermProvider>
                <RetailerNationalityProvider>
                  <RetailerMultipleStoresProvider>
                    <RetailerFlashSaleProvider>
                      <RetailerInsiderProvider>
                        <RetailerBusinessCategoryProvider>
                          <HasDefaultReturnWindowProvider>
                            <ExpandingOfferProvider>
                              <IsRetailerCreatedWithinLast30DaysProvider>
                                {children}
                              </IsRetailerCreatedWithinLast30DaysProvider>
                            </ExpandingOfferProvider>
                          </HasDefaultReturnWindowProvider>
                        </RetailerBusinessCategoryProvider>
                      </RetailerInsiderProvider>
                    </RetailerFlashSaleProvider>
                  </RetailerMultipleStoresProvider>
                </RetailerNationalityProvider>
              </RetailerPaymentTermProvider>
            </RetailerSubUserProvider>
          </RetailerHighReturnerProvider>
        </RetailerStatusProvider>
      </RetailerTypeProvider>
    </RetailerFinancialProvider>
  );
};
